<div class="pagination-container">
  <!-- Botão anterior -->
  <button
    mat-icon-button
    (click)="goToPreviousPage()"
    [disabled]="currentPage == 1"
    [ngClass]="currentPage == 1 ? 'disabled' : ''"
    class="btn-pagination"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <!-- Exibe o intervalo de registros -->
  <div class="pagination-info">
    {{ (currentPage - 1) * pageSize + 1 }} -
    {{
      currentPage * pageSize > totalRecords
        ? totalRecords
        : currentPage * pageSize
    }}
    de {{ totalRecords }}
  </div>

  <!-- Botão próximo -->
  <button
    mat-icon-button
    (click)="goToNextPage()"
    [disabled]="currentPage * pageSize >= totalRecords"
    [ngClass]="currentPage * pageSize >= totalRecords ? 'disabled' : ''"
    class="btn-pagination"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
